export default __webpack_public_path__ + "static/media/img-logo-redis.d9c89e2c.svg";